import { apiSlice } from "../../app/api/apiSlice";

export const reasonApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRevisionRfids: builder.query<string[], string>({
      query: (date) => ({
          url:`/Reason/GetRfids?date=${date}`,
          responseHandler: 'json'
      })
  }),

    postRevisionReason: builder.mutation({
      query: (body) => ({
          url: '/Reason/PostReason',
          method: 'POST',
          // responseHandler: 'json',
          body : {
            ...body
          }
      })
    }),
  }),
});

export const {
  useLazyGetRevisionRfidsQuery,
  usePostRevisionReasonMutation,
} = reasonApiSlice;
